<template>
    <div class="shop-dark-wrapper px-4 px-sm-6 px-md-10 d-flex flex-column align-center justify-center" style="min-height: 100vh; padding-bottom: 0;">
        <div class="glass-card pa-8 text-center animate-fade-in-up stagger-1" style="max-width: 600px; width: 100%;">
            <!-- Logo -->
            <v-img height="50px" class="mb-8" contain src="/img/roodyLogoGreen.png"></v-img>

            <!-- Loading Spinner -->
            <div class="my-10 d-flex justify-center">
                <v-progress-circular 
                    :size="90" 
                    :width="8" 
                    color="#00B074" 
                    indeterminate
                    style="filter: drop-shadow(0 0 8px rgba(0, 176, 116, 0.4));"
                ></v-progress-circular>
            </div>

            <!-- Messages -->
            <h2 class="text-h5 font-weight-black white--text mb-3" style="line-height: 1.3;">
                Zahlung wird geprüft
            </h2>
            <p class="grey--text text--lighten-1 mb-0" style="font-size: 1rem; line-height: 1.5;">
                Bitte gedulde dich einen Moment. Deine Zahlung wird verarbeitet und du wirst automatisch weitergeleitet.
            </p>
        </div>
    </div>
</template>
  
<script>
import api from '../../api'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
    async created() {
        this.checkPayment()
    },
    methods: {
        async checkPayment() {
            setTimeout(async () => {
                let transactionId = this.$route.query.datatransTrxId
                this.$toast.info('Deine Zahlung wird geprüft bitte nicht neu laden!')
                let payment = await api.checkPaymentStatus(transactionId)
                if (payment.paymentStatus === 'settled' || payment.paymentStatus === 'transmitted') {
                    this.$toast.success('Die Zahlung wurde übermittelt.')
                    this.$router.push('/shop/purchase/infos/' + transactionId)
                } else {
                    this.$toast.error('Deine Zahlung ist fehlgeschlagen. Bitte versuche es erneut')
                    this.$router.push('/shop/checkout')
                }
            }, 300)
        },
    },
}
</script>

<style>
@import './shopCommon.css';
</style>

  